import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Space, Tooltip } from 'antd';
import useDictionary from 'src/hooks/useDictionary';
import { getDictionaryKey } from 'src/misc/Misc';
import { MdInfoOutline } from 'react-icons/md';

const EventFiltersCheckboxGroup = ({ entityType, options, value, onChange }) => {
  const actionDictionary = useDictionary('sa-events-action');

  useEffect(() => {
    console.log('filter value', value);
  }, [value]);

  const localOnChange = (e) => {
    let newValue = value ? [...value] : [];
    if (e.target.checked) {
      if (!newValue?.includes(e.target.id)) newValue.push(e.target.id);
    } else {
      newValue = newValue.filter((v) => v !== e.target.id);
    }

    // setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <div className='flex flex-col gap-1'>
      {options?.map((option) => (
        <Checkbox key={option} id={option} checked={value?.includes(option)} onChange={localOnChange}>
          <Space className='btn'>
            <div>{actionDictionary && getDictionaryKey(actionDictionary, `${entityType}-${option}`)?.valueJson?.label}</div>
            <Tooltip title={getDictionaryKey(actionDictionary, `${entityType}-${option}`)?.valueJson?.desc ?? 'no description'}>
              <MdInfoOutline className='text-xs opacity-60' />
            </Tooltip>
          </Space>
        </Checkbox>
      ))}
    </div>
  );
};

EventFiltersCheckboxGroup.propTypes = {
  entityType: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EventFiltersCheckboxGroup;
